import React from 'react';
import { Outlet, Link, useNavigate, useLocation } from 'react-router-dom';

const AdminLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const adminUser = JSON.parse(localStorage.getItem('adminUser') || '{}');

  const handleLogout = () => {
    localStorage.removeItem('adminToken');
    localStorage.removeItem('adminUser');
    navigate('/admin/login');
  };

  const isActive = (path) => {
    return location.pathname === path;
  };

  const navLinkStyle = (path) => ({
    display: 'block',
    padding: '0.75rem 1rem',
    color: isActive(path) ? '#4A90E2' : '#666',
    textDecoration: 'none',
    borderRadius: '6px',
    marginBottom: '0.25rem',
    background: isActive(path) ? '#e3f2fd' : 'transparent',
    fontWeight: isActive(path) ? '600' : '400',
    transition: 'all 0.2s'
  });

  return (
    <div style={{ minHeight: '100vh', background: '#f5f5f5' }}>
      <header style={{
        background: 'linear-gradient(135deg, #4A90E2 0%, #357ABD 100%)',
        color: 'white',
        padding: '1rem',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
      }}>
        <div style={{
          maxWidth: '1400px',
          margin: '0 auto',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
          <div>
            <h1 style={{ margin: '0', fontSize: '1.25rem' }}>Admin Portal</h1>
            <p style={{ margin: '0', fontSize: '0.8rem', opacity: 0.9 }}>
              Goodwin Barrett Client Portal Management
            </p>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
            <span style={{ fontSize: '0.9rem' }}>{adminUser.name || adminUser.email}</span>
            <button
              onClick={handleLogout}
              style={{
                padding: '0.5rem 1rem',
                background: 'rgba(255,255,255,0.2)',
                color: 'white',
                border: '1px solid rgba(255,255,255,0.3)',
                borderRadius: '6px',
                cursor: 'pointer',
                fontSize: '0.9rem',
                fontWeight: '500'
              }}
            >
              Logout
            </button>
          </div>
        </div>
      </header>

      <div style={{ maxWidth: '1400px', margin: '0 auto', display: 'flex', gap: '2rem', padding: '2rem' }}>
        <aside style={{
          width: '250px',
          background: 'white',
          borderRadius: '8px',
          padding: '1rem',
          height: 'fit-content',
          boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
        }}>
          <nav>
            <Link to="/admin/dashboard" style={navLinkStyle('/admin/dashboard')}>
              Dashboard
            </Link>
            <Link to="/admin/status-mappings" style={navLinkStyle('/admin/status-mappings')}>
              Status Mappings
            </Link>
            <Link to="/admin/faqs" style={navLinkStyle('/admin/faqs')}>
              FAQ Management
            </Link>
          </nav>
        </aside>

        <main style={{ flex: 1 }}>
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;
